import type { Domain, PaginatedResponse } from '@/domain/types'
import { useApiQuery, type QueryState } from '@/api/useApiQuery'

export interface DomainsQuery {
  page?: number
  pageSize?: number
  q?: string
  includeInactive?: boolean
  asOf?: string
}

/**
 * Fetches GET /api/domains with the standard pagination envelope.
 * The path (with query string) drives the cache key — search/filter
 * changes naturally re-fire the request.
 */
export function useDomains(query: DomainsQuery): QueryState<PaginatedResponse<Domain>> {
  return useApiQuery<PaginatedResponse<Domain>>(buildPath(query))
}

function buildPath(q: DomainsQuery): string {
  const params = new URLSearchParams()
  if (q.page !== undefined) params.set('page', String(q.page))
  if (q.pageSize !== undefined) params.set('pageSize', String(q.pageSize))
  if (q.q) params.set('q', q.q)
  if (q.includeInactive) params.set('includeInactive', 'true')
  if (q.asOf) params.set('asOf', q.asOf)
  const qs = params.toString()
  return qs ? `/api/domains?${qs}` : '/api/domains'
}
